import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//Redux

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import UploadArticleModal from "./UploadArticleModal";


//Serivce
const ArticleMasterBulkUpload = () => {
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [data, setData] = useState();

  // const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
  //   useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
  

  const orderSchedulingListColInfo = [
    {
      name: "Article",
      selector: (row) => row?.article,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.article}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Article Description",
      selector: (row) => row?.articleDescription,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.articleDescription}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Division",
      selector: (row) => row?.division,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.division}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Article Type",
      selector: (row) => row?.articleType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.articleType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Article Category",
      selector: (row) => row?.articleCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.articleCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Merchandise Category",
      selector: (row) => row?.merchandiseCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.merchandiseCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Characteristic Profile",
      selector: (row) => row?.characteristicProfile,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.characteristicProfile}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Base Unit Of Measure",
      selector: (row) => row?.baseUnitOfMeasure,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.baseUnitOfMeasure}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160",
    },
    {
      name: "Net Weight",
      selector: (row) => row?.netWeight,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.netWeight}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Gross Weight",
      selector: (row) => row?.grossWeight,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.grossWeight}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Weight Unit",
      selector: (row) => row?.weightUnit,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.weightUnit}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Commodity Code For Foreign Trade",
      selector: (row) => row?.commodityCodeImportCodeNumberForForeignTrade,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.commodityCodeImportCodeNumberForForeignTrade}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Style",
      selector: (row) => row?.style,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.style}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Content Group",
      selector: (row) => row?.fabricContentGroup,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricContentGroup}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Content",
      selector: (row) => row?.fabricContent,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricContent}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Old Article Number",
      selector: (row) => row?.oldArticleNumber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.oldArticleNumber}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "External Merchandise Category",
      selector: (row) => row?.externalMerchandiseCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.externalMerchandiseCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Brand",
      selector: (row) => row?.brand,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.brand}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fiber Code For Textiles Component1",
      selector: (row) => row?.fiberCodeForTextilesComponent1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextilesComponent1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Percentage Share Of Fiber Component1",
      selector: (row) => row?.percentageShareOfFiberComponent1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiberComponent1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fiber Code For Textiles Component2",
      selector: (row) => row?.fiberCodeForTextilesComponent2,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextilesComponent2}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Percentage Share Of Fiber Component2",
      selector: (row) => row?.percentageShareOfFiberComponent2,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiberComponent2}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fiber Code For Textiles Component3",
      selector: (row) => row?.fiberCodeForTextilesComponent3,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextilesComponent3}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Percentage Share Of Fiber Component3",
      selector: (row) => row?.percentageShareOfFiberComponent3,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiberComponent3}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fiber Code For Textiles Component4",
      selector: (row) => row?.fiberCodeForTextilesComponent4,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextilesComponent4}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Percentage Share Of Fiber Component4",
      selector: (row) => row?.percentageShareOfFiberComponent4,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiberComponent4}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fiber Code For Textiles Component5",
      selector: (row) => row?.fiberCodeForTextilesComponent5,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextilesComponent5}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Percentage Share Of Fiber Component5",
      selector: (row) => row?.percentageShareOfFiberComponent5,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiberComponent5}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Country Of Origin Of Article Non Preferential Origin",
      selector: (row) => row?.countryOfOriginOfArticleNonPreferentialOrigin,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.countryOfOriginOfArticleNonPreferentialOrigin}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Future Planned Price1",
      selector: (row) => row?.futurePlannedPrice1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.futurePlannedPrice1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Date From Which Future Planned Price1 Is Valid",
      selector: (row) => row?.dateFromWhichFuturePlannedPrice1IsValid,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.dateFromWhichFuturePlannedPrice1IsValid}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Control Code For Consumption Taxes In Foreign Trade",
      selector: (row) => row?.controlCodeForConsumptionTaxesInForeignTrade,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.controlCodeForConsumptionTaxesInForeignTrade}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Season Category",
      selector: (row) => row?.seasonCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.seasonCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Indicator Season Active In Inventory Management",
      selector: (row) => row?.indicatorSeasonActiveInInventoryManagement,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.indicatorSeasonActiveInInventoryManagement}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Segmentation Structure",
      selector: (row) => row?.segmentationStructure,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.segmentationStructure}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Segmentation Strategy",
      selector: (row) => row?.segmentationStrategy,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.segmentationStrategy}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Segmentation Relevant",
      selector: (row) => row?.segmentationRelevant,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.segmentationRelevant}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Article Conversion Id For Characteristic Value Conversion",
      selector: (row) => row?.articleConversionIdForCharacteristicValueConversion,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.articleConversionIdForCharacteristicValueConversion}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fashion Grade",
      selector: (row) => row?.fashionGrade,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fashionGrade}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Season Year",
      selector: (row) => row?.seasonYear,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.seasonYear}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Season",
      selector: (row) => row?.season,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.season}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fashion Collection",
      selector: (row) => row?.fashionCollection,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fashionCollection}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fashion Theme",
      selector: (row) => row?.fashionTheme,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fashionTheme}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Season Indicator",
      selector: (row) => row?.seasonIndicator,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.seasonIndicator}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Storage Sect Id",
      selector: (row) => row?.storageSectId,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.storageSectId}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Stock Placement",
      selector: (row) => row?.stockPlacement,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.stockPlacement}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Stock Removal",
      selector: (row) => row?.stockRemoval,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.stockRemoval}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Gender",
      selector: (row) => row?.gender,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.gender}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sub Gender",
      selector: (row) => row?.subGender,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.subGender}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Style Description",
      selector: (row) => row?.styleDescription,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.styleDescription}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Multiple Mrp",
      selector: (row) => row?.multipleMrp,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.multipleMrp}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Code",
      selector: (row) => row?.fabricCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Finish",
      selector: (row) => row?.fabricFinish,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricFinish}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Type",
      selector: (row) => row?.fabricType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Weave",
      selector: (row) => row?.weave,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.weave}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Yarn Type",
      selector: (row) => row?.yarnType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.yarnType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Leather",
      selector: (row) => row?.leather,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.leather}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fit",
      selector: (row) => row?.fit,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fit}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fit Name",
      selector: (row) => row?.fitName,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fitName}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Design Code",
      selector: (row) => row?.designCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.designCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Design Type",
      selector: (row) => row?.designType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.designType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Collor Neck Pleate",
      selector: (row) => row?.collorNeckPleate,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.collorNeckPleate}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sleev",
      selector: (row) => row?.sleev,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.sleev}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Occasion",
      selector: (row) => row?.occasion,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.occasion}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Garment Finish",
      selector: (row) => row?.garmentFinish,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.garmentFinish}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Inseam",
      selector: (row) => row?.inseam,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.inseam}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sub Label",
      selector: (row) => row?.subLabel,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.subLabel}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Category Group",
      selector: (row) => row?.categoryGroup,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.categoryGroup}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sub Sub Category",
      selector: (row) => row?.subSubCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.subSubCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Category Type",
      selector: (row) => row?.categoryType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.categoryType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Selable",
      selector: (row) => row?.selable,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.selable}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Returnable",
      selector: (row) => row?.returnable,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.returnable}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class1",
      selector: (row) => row?.class1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class2",
      selector: (row) => row?.class2,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class2}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class3",
      selector: (row) => row?.class3,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class3}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class4",
      selector: (row) => row?.class4,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class4}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Free Text Barcode1",
      selector: (row) => row?.freeTextBarcode1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.freeTextBarcode1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Free Text Barcode2",
      selector: (row) => row?.freeTextBarcode2,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.freeTextBarcode2}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Free Text Barcode3",
      selector: (row) => row?.freeTextBarcode3,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.freeTextBarcode3}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Wrap Count",
      selector: (row) => row?.wrapCount,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.wrapCount}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Weft Count",
      selector: (row) => row?.weftCount,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.weftCount}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Ends Per Inch",
      selector: (row) => row?.endsPerInch,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.endsPerInch}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Picks Per Inch",
      selector: (row) => row?.picksPerInch,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.picksPerInch}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Classification",
      selector: (row) => row?.taxClassification,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.taxClassification}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
  ]

  const clearData = () => {
    setData();
  };
  // const handleInputChange = (documentNumber, event) => {
  //   const { name, value } = event.target;
  //   setData((prevRows) =>
  //     prevRows.map((row) =>
  //       row.documentNumber === documentNumber ? { ...row, [name]: value } : row
  //     )
  //   );
  // };

  // const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  // const handleFormData = (data) => {
  //   setData(data);
  //   console.log(">>Received formData from child:", data);
  //   // You can set it in state or use it as needed
  // };

  // const handleUploadSuccess = (data) => {
  //   console.log("Uploaded:", data);
  //   // Do something with uploaded data
  // };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Article Master Bulk Upload</h2>
                <p className="subText">Article Master Bulk Upload List</p>
              </Col>
            </Row>
            <hr />

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AU</span>
                    </Col>
                    <Col xs={7} md={7} lg={7}>
                      <span className="headerTitle">Article Master Bulk Upload</span>
                      <span className="subHeaderTitle">
                        View of Article Master upload list
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1}>
                      <button
                        className="btnTable"
                     onClick={() => setShowUploadModal(true)} 
                      >
                        Upload
                      </button>
                    </Col>
                    <Col xs={1} md={1} lg={1}>
                      <button
                        className="btnTable"
                      // onClick={() => setShowSupplierInviteModal(true)}
                      >
                        Create
                      </button>
                    </Col>
                    <Col xs={1} md={1} lg={1}>
                      <button
                        className="btnTable btn-danger"
                        onClick={clearData}
                      >
                        Clear
                      </button>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={orderSchedulingListColInfo}
                          data={data}
                          // data={""}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
   
          <UploadArticleModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        // onSuccessUpload={handleUploadSuccess}
      />
    </main>
  );
};

export default ArticleMasterBulkUpload;
